<template>
    <ContentComp>
        <FormLayout class="gap-0">
            <FormLayoutRowSeparator text="device.position" />
            <FormLayoutRow>
                <FormLayoutLabel text="device.positiontime" />
                <span v-if="(mappoint?.UTCTime ?? 0) > 0">
                    <DateComp
                        :value="utcToLocalTime(mappoint?.UTCTime)"
                        class="text-start"
                    />
                    ({{ mappoint?.UTCTime }})<TooltipHelp text="device.positiontimehelp" />
                </span>
                <template v-else-if="data?.LastBatteryUpdate != null">
                    <DateComp
                        :value="data?.LastBatteryUpdate"
                        class="text-start"
                    />
                </template>
                <AlertMessage
                    v-else
                    size="sm"
                    type="info"
                    >{{ $tm('tracking.noknowntime') }}</AlertMessage
                >
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel text="device.positionlatitude" />
                <span>{{ position?.Latitude }}</span>
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel text="device.positionlongitude" />
                <span>{{ position?.Longitude }}</span>
            </FormLayoutRow>
            <FormLayoutRow v-if="position != null && position.Altitude != null">
                <FormLayoutLabel text="device.positionaltitude" />
                <span>{{ $tm('general.altitude', position?.Altitude) }}</span>
            </FormLayoutRow>
            <FormLayoutRow v-if="position != null">
                <FormLayoutLabel text="device.positionspeed" />
                <span>{{ $tm('general.speed', position?.Speed) }}</span>
            </FormLayoutRow>
            <FormLayoutRow v-if="position != null">
                <FormLayoutLabel text="device.positionaccuracy" />
                <DisplayAccuracy :value="position?.Accuracy" />
            </FormLayoutRow>

            <FormLayoutRowSeparator text="device.details" />

            <FormLayoutRow v-if="(data.IMEI ?? '') != ''">
                <FormLayoutLabel text="device.eqdeviceid" />
                <span>{{ data?.IMEI }}</span>
            </FormLayoutRow>

            <FormLayoutRow
                v-if="
                    data.BatteryLevel != null && data.LastBatteryUpdate != null && data.LastBatteryUpdate > new Date(Date.now() - 86400000)
                "
            >
                <FormLayoutLabel text="device.eqdevicepower" />
                <span
                    ><BatteryLevelIcon
                        :battery-level="data.BatteryLevel"
                        :tooltip="false" />

                    {{ data.BatteryLevel }}%
                    <DateComp
                        class="ms-3 text-start"
                        :value="data.LastBatteryUpdate"
                /></span>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { AlertMessage, BatteryLevelIcon, ContentComp, DateComp, TooltipHelp } from '@/components';
import DisplayAccuracy from '@/components/Basic/DisplayAccuracy.vue';
import { FormLayout, FormLayoutRow, FormLayoutRowSeparator } from '@/components/Form';
import FormLayoutLabel from '@/components/Form/FormLayoutLabel.vue';
import { $tm } from '@/locize';
import type { MapPoint, TrackingDevice } from '@/objects/generated';
import { utcToLocalTime } from '@/utilities/dateutils';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        data: TrackingDevice;

        mappoint?: MapPoint | null;

        view?: 'all' | 'device';
    }>(),
    {
        view: 'all',
        mappoint: null,
    },
);

/**
 * Keep track of the position of the device. based on last battery time and last received position
 */
const position = computed(() => {
    return props.mappoint ?? props.data?.LastKnownPosition;
});
</script>
